export const board = [
    ["└","┐","├","─","╴","├","┘","╶","┤"],
    ["╶","┼","┼","┬","─","┤","┌","─","┤"],
    ["─","┤","│","╵","╶","┼","┤","┌","┼"],
    ["┌","┴","┤","┌","─","┤","├","┴","┤"],
    ["├","─","┼","┤","╷","├","┼","─","┤"],
    ["┤","╶","┤","└","┴","┤","│","╶","┼"]
]

export const start =[1,2]
export const end = [4,6]

export const doors = {
    "└":["↑","→"],
    "┌":["↓","→"],
    "┐":["←","↓"],
    "┘":["←","↑"],
    "├":["↑","→","↓"],
    "┬":["→","↓","←"],
    "┤":["↑","↓","←"],
    "┴":["↑","→","←"],
    "╶":["→"],
    "╵":["↑"],
    "╴":["←"],
    "╷":["↓"],
    "┼":["↑","→","↓","←"],
    "─":["→","←"],
    "│":["↑","↓"]
    }

